/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateInvoiceToContractorEmailDto
 */
export interface CreateInvoiceToContractorEmailDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateInvoiceToContractorEmailDto
     */
    invoiceIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateInvoiceToContractorEmailDto
     */
    emailFromId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvoiceToContractorEmailDto
     */
    emailTo: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvoiceToContractorEmailDto
     */
    emailDw: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvoiceToContractorEmailDto
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvoiceToContractorEmailDto
     */
    message: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateInvoiceToContractorEmailDto
     */
    duplicate: boolean;
}

/**
 * Check if a given object implements the CreateInvoiceToContractorEmailDto interface.
 */
export function instanceOfCreateInvoiceToContractorEmailDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "invoiceIds" in value;
    isInstance = isInstance && "emailTo" in value;
    isInstance = isInstance && "emailDw" in value;
    isInstance = isInstance && "subject" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "duplicate" in value;

    return isInstance;
}

export function CreateInvoiceToContractorEmailDtoFromJSON(json: any): CreateInvoiceToContractorEmailDto {
    return CreateInvoiceToContractorEmailDtoFromJSONTyped(json, false);
}

export function CreateInvoiceToContractorEmailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateInvoiceToContractorEmailDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'invoiceIds': json['invoiceIds'],
        'emailFromId': !exists(json, 'emailFromId') ? undefined : json['emailFromId'],
        'emailTo': json['emailTo'],
        'emailDw': json['emailDw'],
        'subject': json['subject'],
        'message': json['message'],
        'duplicate': json['duplicate'],
    };
}

export function CreateInvoiceToContractorEmailDtoToJSON(value?: CreateInvoiceToContractorEmailDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'invoiceIds': value.invoiceIds,
        'emailFromId': value.emailFromId,
        'emailTo': value.emailTo,
        'emailDw': value.emailDw,
        'subject': value.subject,
        'message': value.message,
        'duplicate': value.duplicate,
    };
}

